export const REQUEST_QUERY_LIMIT_SIZE = 30720;
export const ALLOWED_STACK_LIST_FOR_DOMAINS = ['qa', 'prod', 'uat'];
